import { useState, useEffect } from 'react';
import config from '../config'; 

const useTranslation = () => {
  const [traduzioni, setTraduzioni] = useState({});
  const [linguaCorrente, setLinguaCorrente] = useState(
    localStorage.getItem('language') || config.languages.default
  );

  useEffect(() => {
    const caricaTraduzioni = async () => {
      try {
        const moduloLingua = await import(`./translations/${linguaCorrente}.js`); // <-- percorso aggiornato
        setTraduzioni(moduloLingua.default);
      } catch (error) {
        console.error(`Errore nel caricamento delle traduzioni per ${linguaCorrente}:`, error);
        if (linguaCorrente !== config.languages.default) {
          const moduloDefault = await import(`./translations/${config.languages.default}.js`); // <-- percorso aggiornato
          setTraduzioni(moduloDefault.default);
        }
      }
    };

    caricaTraduzioni();

    const gestoreCambioLingua = (event) => {
      const nuovaLingua = event.detail.language;
      setLinguaCorrente(nuovaLingua);
    };

    window.addEventListener('languageChange', gestoreCambioLingua);

    return () => {
      window.removeEventListener('languageChange', gestoreCambioLingua);
    };
  }, [linguaCorrente]);

  const t = (chiave) => {
    if (!traduzioni[chiave]) {
      
      return chiave;
    }
    return traduzioni[chiave];
  };

  return { t, linguaCorrente };
};

export default useTranslation;